
export { isResultWithErrors, getErrors, getSuccessResult } from './api/vizPortalWebClientHelpers';
export { VizPortalWebClientRequester } from './api/VizPortalWebClientRequester';

export { Filter } from './common/Filter';
export { GetItemsParams } from './common/GetItemsParams';
export { OrderClauses } from './common/Order';
export { Page } from './common/Page';

export { AuthenticationManager } from './managers/AuthenticationManager';
export { SessionManager } from './managers/SessionManager';

export * from './requester/WebClientFetchRequester';
export * from './requester/webClientMethod'
export * from './requester/webClientRequest'
export * from './requester/webClientRequester'
export * from './requester/webClientResponse';

// Exporting VizPortalWebClientRequesterGenerator wrapped in a class for the VizClient Saltarelle code,
// which doesn't allow functions to exist outside of classes.
import * as VizPortalWebClientRequesterGeneratorClass from './util/vizPortalWebClientRequesterGenerator';
export { VizPortalWebClientRequesterGeneratorClass };
